module.exports = __webpack_public_path__ + "img/commercelogo-white.a2daaf0a.svg";